import React, { FC } from 'react'
import cn from 'clsx'
import s from './ModalInner.module.scss'
import { Text, CustomImage } from '@components/ui'

export interface ModalInnerProps {
  className?: string
  section: any
  title: string
  variant: string
  showImage: boolean
}

const ModalInner: FC<ModalInnerProps> = ({
  className,
  title,
  section,
  variant,
  showImage
}) => {
  return (
    <div className={s.root}>
      <Text className={cn(s.title, {[s.titleWide]: !showImage})}>
        {title}
      </Text>
      <div className={s.container}>
        {variant == 'two' && showImage &&
          section.map((block: any, index: number) => (
            <div className={s.block} key={`block-${index}`}>
              <div className={s.image}>
                <CustomImage data={block} />
              </div>
              <Text html={block.detail} className={s.detail} />
            </div>
          ))}

        {variant != 'two' && showImage && (
          <div className={s.block}>
            <div className={s.image}>
              <CustomImage data={section} />
            </div>
            <Text html={section.detail} className={s.detail} />
          </div>
        )}
        {variant == 'two' && !showImage &&
          section.map((block: any, index: number) => (
            <div className={s.block} key={`block-${index}`}>
              {/* <div className={s.image}>
                <CustomImage data={block} />
              </div> */}
              <Text html={block.detail} className={s.detailWide} />
            </div>
          ))}

        {variant != 'two' && !showImage && (
          <div className={s.block}>
         
          <Text html={section.detail} className={s.detailWide} />
        </div>
        )}
      </div>
    </div>
  )
}

export default ModalInner
